import { AgentAvatar } from "~/pages/manifold-nextgen/components/agents/AgentAvatar";
import type { RunAgentLabels } from "~/pages/manifold-nextgen/components/evals/useEvalApi";

/**
 * The avatar of the agent a run targeted. An agent that has since been deleted has
 * no record to read a seed from, so its id seeds the avatar instead — it still
 * draws, and draws the same way every time.
 */
export const RunAgentAvatar = ({
  agentId,
  agentLabels,
  size,
}: {
  agentId: string;
  agentLabels: RunAgentLabels;
  size: number;
}) => (
  <span data-testid="run-agent-avatar" className="inline-flex shrink-0">
    <AgentAvatar
      agent={agentLabels.agentRecord(agentId) ?? { id: agentId }}
      size={size}
      aria-hidden
    />
  </span>
);
